import { TemplateQuestionsTypes } from '../Fillgrid'

enum AttachmentKey {
  NAME = 'name',
  LABEL = 'label'
}

interface AttachmentKeyOption {
  key: AttachmentKey
  label: string
}

interface AttachmentObject {
  name: string
  label: string
  type: TemplateQuestionsTypes
}

interface AttachmentFormat {
  [attachmentKey: string]: string
}

interface VariableFill {
  variableId: string
  variableValue: string
}
const SelectableAttachments = [
  TemplateQuestionsTypes.AUDIO,
  TemplateQuestionsTypes.FILE,
  TemplateQuestionsTypes.PDF,
  TemplateQuestionsTypes.PHOTO
] as TemplateQuestionsTypes[]

export {
  AttachmentKey,
  AttachmentKeyOption,
  AttachmentObject,
  AttachmentFormat,
  VariableFill,
  SelectableAttachments
}
